import { render, staticRenderFns } from "./SaleChart.vue?vue&type=template&id=6688141a&scoped=true&"
import script from "./SaleChart.vue?vue&type=script&lang=js&"
export * from "./SaleChart.vue?vue&type=script&lang=js&"
import style0 from "./SaleChart.vue?vue&type=style&index=0&id=6688141a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6688141a",
  null
  
)

export default component.exports